@if (show) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="saveDialog">
        {{message}}
        <fa-icon class="mt-3 z-10" [icon]="faFloppyDisk" size="5x"></fa-icon>
        <fa-icon class="backgroundSave" [icon]="faFloppyDisk" size="10x"></fa-icon>
      </div>
    </div>
  </div>
}
